// extracted by mini-css-extract-plugin
export var addButton = "_nq-0";
export var border = "_nq-8";
export var check = "_nq-h";
export var danger = "_nq-6";
export var dropdownContainer = "_nq-1";
export var editModalBody = "_nq-j";
export var footerContainer = "_nq-i";
export var fullWidth = "_nq-a";
export var hide = "_nq-9";
export var icon = "_nq-3";
export var input = "_nq-7";
export var inputFlex = "_nq-b";
export var inputWrapper = "_nq-c";
export var manualFocus = "_nq-5";
export var optionButton = "_nq-4";
export var pillWrapper = "_nq-e";
export var pointer = "_nq-2";
export var showOverflow = "_nq-f";
export var tagsFlex = "_nq-d";
export var xButton = "_nq-g";